/** session_players.status values that mean the player is still on the session roster. */
export const SESSION_ROSTER_STATUSES = ['active', 'signed_up', 'paused'];

/**
 * Count players still on the roster from session_players rows.
 * @param {Array<{ status?: string }>} rows
 * @returns {number}
 */
export function countSessionRosterPlayers(rows) {
  return (rows || []).filter((row) => SESSION_ROSTER_STATUSES.includes(row.status)).length;
}

/**
 * Player count line for home live / upcoming session cards.
 */
export function formatHomeSessionPlayerMeta({
  isOngoing,
  playersInSession,
  confirmedPlayers,
  maxPlayers,
}) {
  if (isOngoing) {
    return `Players in session: ${playersInSession ?? 0}`;
  }
  const confirmed = confirmedPlayers ?? 0;
  const max = maxPlayers ?? 16;
  return `${confirmed} / ${max} players`;
}
